export const OPTIMIZED_IMAGE_WIDTHS = [384, 640, 750, 828, 1080, 1200, 1920] as const;

export const optimizedImageQuality = (width: number): number => (width >= 1080 ? 90 : 80);

const isOptimizable = (src: string): boolean => src.startsWith('/media/');

const normalizeOrigin = (origin: string | undefined): string => origin?.trim().replace(/\/+$/, '') ?? '';

export const optimizedImageUrl = (
  src: string,
  width: number,
  staticOrigin: string | undefined = process.env.NEXT_PUBLIC_STATIC_ORIGIN,
): string =>
  `${normalizeOrigin(staticOrigin)}/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${optimizedImageQuality(width)}`;

export type OptimizedImageAttributes = { src: string; srcSet?: string; sizes?: string };

export const optimizedImageAttributes = (
  src: string,
  sizes = '100vw',
  staticOrigin: string | undefined = process.env.NEXT_PUBLIC_STATIC_ORIGIN,
): OptimizedImageAttributes => {
  if (!isOptimizable(src)) return { src };

  return {
    src: optimizedImageUrl(src, OPTIMIZED_IMAGE_WIDTHS[OPTIMIZED_IMAGE_WIDTHS.length - 1], staticOrigin),
    srcSet: OPTIMIZED_IMAGE_WIDTHS.map((width) => `${optimizedImageUrl(src, width, staticOrigin)} ${width}w`).join(
      ', ',
    ),
    sizes,
  };
};
